<script>
	import CustomTable from "src/components/CustomTable/CustomTable.svelte";
	import { getCarActivities } from "src/services/vehicle";
	import { onMount } from "svelte";
	import queryString from "query-string";
	import { useLocation } from "svelte-routing";

	export let vehicleId;

	const columns = [
		{
			key: "createdAt",
			label: "Date",
			type: "date",
			format: "DD MMM YYYY, HH:mm",
			className: "table-datetime",
		},
		{
			key: "remark",
			label: "Remark",
			type: "joinColumn",
		},
	];

	const location = useLocation();
	let data = [];

	$: params = queryString.parse($location.search);

	async function fetchData() {
		const response = await getCarActivities(
			vehicleId,
			"Vehicle",
			params.page
		);
		data = response.data.dataList;
		return;
	}

	onMount(async () => {
		await fetchData();
	});

	$: if ((vehicleId && params.page) || params.pageNumber) {
		fetchData();
	}
</script>

<CustomTable
	{columns}
	rows={data}
	useNavigation={true}
	noHeaders
	borderless
	hover={false}
/>
